import { useState } from "react";
import type { LodProfile } from "@/app/(workspace)/_types/project";

export type ModalType =
  | "upload"
  | "create"
  | "progress"
  | "message"
  | "editTitle"
  | "lodBackfill";
export type ModalSize = "sm" | "md" | "lg" | "xl";

export interface ModalData {
  type: ModalType;
  title?: string;
  size?: ModalSize;
  message?: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: (file?: File | null, detail?: any) => void | Promise<void>;
  selectedFile?: File;
  uploadKey?: string;
  // EditTitleModal 전용
  projectId?: string;
  currentTitle?: string;
  onTitleUpdate?: (newTitle: string) => void | Promise<void>;
  // LodBackfillModal 전용 (projectId 재사용)
  initialLodProfile?: LodProfile;
  initialUseExtSplats?: boolean;
}

export const useModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState<ModalData | null>(null);

  const openModal = (data: ModalData, replace = false) => {
    if (replace) {
      setModalData(data);
      if (!isOpen) setIsOpen(true);

      return;
    }

    setModalData(data);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setModalData(null);
  };

  return { isOpen, modalData, openModal, closeModal };
};
